import React from "react";
import { RequestHost } from "../types/headers";

export const DomainContext = React.createContext<RequestHost | null>(null);
export const HostContext = React.createContext<string | null>(null);
export const HostAuthorContext = React.createContext<string | null>(null);
